import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

const Blog = () => {
  const [selectedCategory, setSelectedCategory] = useState('All');
  const [currentPage, setCurrentPage] = useState(1);
  const blogsPerPage = 3;

  const categories = [
    'All',
    'SEO',
    'Social Media',
    'Digital Marketing',
    'Patient Acquisition',
    'Healthcare Technology',
    'Web Development',
    'Content Marketing'
  ];

  const blogPosts = [
    // SEO - 2 blogs
    {
      id: 1,
      title: 'How to Optimize Your Medical Practice Website for Local SEO in 2026',
      category: 'SEO',
      image: '/images/Blog4.png',
      excerpt: 'Discover the latest local SEO strategies specifically designed for healthcare providers. Learn how to rank higher in local searches and attract more patients to your medical practice.',
      author: 'Docmize Team',
      date: 'February 3, 2026',
      readTime: '8 min read',
      link: '/blog/local-seo-guide'
    },
    {
      id: 2,
      title: 'SEO Content Strategy for Healthcare Websites: A Complete Blueprint',
      category: 'SEO',
      image: '/images/Blog5.png',
      excerpt: 'Master the art of creating SEO-optimized healthcare content that ranks well and converts visitors into patients. Learn keyword research, content structuring, and on-page optimization techniques.',
      author: 'Docmize Team',
      date: 'January 25, 2026',
      readTime: '10 min read',
      link: '/blog/seo-content-strategy'
    },
    
    // Social Media - 2 blogs
    {
      id: 3,
      title: 'Top 10 Social Media Marketing Strategies for Doctors in 2026',
      category: 'Social Media',
      image:  '/images/Blog2.png',
      excerpt: 'Social media is transforming healthcare marketing. Explore proven strategies that help doctors build their online presence, engage with patients, and grow their practice through Facebook, Instagram, and LinkedIn.',
      author: 'Docmize Team',
      date: 'January 28, 2026',
      readTime: '10 min read',
      link: '/blog/social-media-strategies'
    },
    {
      id: 4,
      title: 'Instagram Marketing for Medical Practices: The 2026 Playbook',
      category: 'Social Media',
      image: '/images/Blog7.png',
      excerpt: 'Unlock the power of Instagram to grow your medical practice. Learn how to create engaging content, use Reels effectively, leverage Instagram Stories, and build a loyal patient community.',
      author: 'Docmize Team',
      date: 'January 15, 2026',
      readTime: '9 min read',
      link: '/blog/instagram-marketing-guide'
    },
    
    // Growth Engine- 2 blogs
    {
      id: 5,
      title: 'The Complete Guide to Google Ads for Healthcare Providers',
      category: 'Digital Marketing',
      image: '/images/Blog6.png',
      excerpt: 'Master Google Ads for your medical practice with our comprehensive guide. Learn about campaign setup, keyword targeting, ad compliance, and optimization techniques that deliver real patient appointments.',
      author: 'Docmize Team',
      date: 'January 20, 2026',
      readTime: '12 min read',
      link: '/blog/google-ads-guide'
    },
    {
      id: 6,
      title: 'Email Marketing for Healthcare: Build Patient Loyalty and Retention',
      category: 'Digital Marketing',
      image: '/images/Blog8.png',
      excerpt: 'Discover how email marketing can help you stay connected with patients, increase appointment bookings, and improve patient retention. Learn best practices for HIPAA-compliant email campaigns.',
      author: 'Docmize Team',
      date: 'January 12, 2026',
      readTime: '11 min read',
      link: '/blog/email-marketing-healthcare'
    },
    
    // Patient Acquisition - 2 blogs
    {
      id: 7,
      title: 'Patient Acquisition Strategies That Work in 2026',
      category: 'Patient Acquisition',
      image: '/images/Blog9.png',
      excerpt: 'Learn proven patient acquisition strategies that help medical practices attract new patients consistently. From online booking systems to referral programs, discover what works in 2026.',
      author: 'Docmize Team',
      date: 'February 1, 2026',
      readTime: '10 min read',
      link: '/blog/patient-acquisition-strategies'
    },
    {
      id: 8,
      title: 'Converting Website Visitors into Booked Appointments: A Data-Driven Approach',
      category: 'Patient Acquisition',
      image: '/images/Blog10.png',
      excerpt: 'Maximize your website conversion rates with proven tactics. Learn how to optimize your booking process, create compelling calls-to-action, and reduce friction in the patient journey.',
      author: 'Docmize Team',
      date: 'January 18, 2026',
      readTime: '9 min read',
      link: '/blog/website-conversion-optimization'
    },
    
    // Healthcare Technology - 2 blogs
    {
      id: 9,
      title: 'AI and Automation in Healthcare Marketing: The Future is Now',
      category: 'Healthcare Technology',
      image:'/images/Blog11.png',
      excerpt: 'Explore how artificial intelligence and automation are revolutionizing healthcare marketing. Learn about chatbots, automated appointment reminders, and AI-powered patient engagement tools.',
      author: 'Docmize Team',
      date: 'January 30, 2026',
      readTime: '11 min read',
      link: '/blog/ai-automation-healthcare'
    },
    {
      id: 10,
      title: 'Telemedicine Marketing: Promoting Your Virtual Care Services',
      category: 'Healthcare Technology',
      image: '/images/Blog12.png',
      excerpt: 'As telemedicine becomes mainstream, learn how to effectively market your virtual care services. Discover strategies to attract patients to your telehealth platform and build trust online.',
      author: 'Docmize Team',
      date: 'January 10, 2026',
      readTime: '8 min read',
      link: '/blog/telemedicine-marketing'
    },
    
    // Web Development - 1 blog
    {
      id: 11,
      title: 'Essential Features Every Medical Practice Website Needs in 2026',
      category: 'Web Development',
      image: '/images/Blog13.png',
      excerpt: 'Building a modern medical practice website? Discover the must-have features including online booking, patient portals, mobile responsiveness, and HIPAA-compliant contact forms.',
      author: 'Docmize Team',
      date: 'January 22, 2026',
      readTime: '10 min read',
      link: '/blog/medical-website-features'
    },
    
    // Content Marketing - 1 blog
    {
      id: 12,
      title: 'Healthcare Content Marketing: How to Educate and Engage Your Patients',
      category: 'Content Marketing',
      image: '/images/Blog14.png',
      excerpt: 'Create valuable healthcare content that educates patients and establishes your expertise. Learn about blog writing, video content, infographics, and patient education resources.',
      author: 'Docmize Team',
      date: 'January 8, 2026',
      readTime: '12 min read',
      link: '/blog/healthcare-content-marketing'
    }
  ];

  // Filter posts by category
  const filteredPosts = selectedCategory === 'All' 
    ? blogPosts 
    : blogPosts.filter(post => post.category === selectedCategory);

  // Pagination Logic
  const indexOfLastPost = currentPage * blogsPerPage;
  const indexOfFirstPost = indexOfLastPost - blogsPerPage;
  const currentPosts = filteredPosts.slice(indexOfFirstPost, indexOfLastPost);
  const totalPages = Math.ceil(filteredPosts.length / blogsPerPage);

  // Change page
  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
    window.scrollTo({ top: 400, behavior: 'smooth' });
  };

  // Handle category change - reset to page 1
  const handleCategoryChange = (category) => {
    setSelectedCategory(category);
    setCurrentPage(1);
  };

  return (
    <div className="font-['Raleway',sans-serif] bg-white text-gray-900 overflow-x-hidden pt-[90px]">
      
      <Navbar />

      {/* HERO SECTION */}
      <section className="relative min-h-[300px] flex items-center justify-center overflow-hidden">
        {/* Background Image with Overlay */}
        <div 
          className="absolute inset-0 bg-cover bg-center"
          style={{
            backgroundImage: `url('https://images.unsplash.com/photo-1499750310107-5fef28a66643?w=1920&q=80')`,
          }}
        />
        {/* Dark Blue Overlay */}
        <div className="absolute inset-0 bg-[#19354a]/90" />
        
        {/* Content */}
        <div className="relative z-10 text-center px-4 sm:px-6">
          <motion.h1 
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-6 sm:mb-8"
          >
            Healthcare Marketing Blog
          </motion.h1>
          
          {/* Breadcrumb Buttons */}
          <motion.div 
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="flex items-center justify-center gap-2 sm:gap-4 flex-wrap"
          >
            <Link 
              to="/" 
              className="px-6 sm:px-8 py-2.5 sm:py-3 bg-[#39a5d3] text-white rounded-full font-semibold hover:bg-[#2a8db8] transition-all text-sm sm:text-base"
            >
              Home
            </Link>
            <span className="text-white text-xl sm:text-2xl">|</span>
            <span className="px-6 sm:px-8 py-2.5 sm:py-3 bg-[#39a5d3] text-white rounded-full font-semibold text-sm sm:text-base">
              Blog
            </span>
          </motion.div>
        </div>
      </section>

      {/* MAIN CONTENT SECTION */}
      <section className="py-12 sm:py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
          
          {/* Page Title */}
          <motion.div 
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5 }}
            className="mb-8 sm:mb-12"
          >
            <p className="text-[#39a5d3] font-semibold text-base sm:text-lg mb-2">
              Latest Insights
            </p>
            <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-[#19354a]">
              Healthcare Growth EngineInsights & Tips
            </h2>
          </motion.div>

          <div className="grid lg:grid-cols-12 gap-8 lg:gap-12">
            
            {/* LEFT SIDE - Blog Posts (Main Content) */}
            <div className="lg:col-span-8">
              
              {currentPosts.map((post, index) => (
                <motion.article
                  key={post.id}
                  initial={{ opacity: 0, y: 40 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.5, delay: index * 0.1 }}
                  className="bg-[#f8f9fa] rounded-xl overflow-hidden hover:shadow-lg transition-all duration-300 mb-6"
                >
                  <div className="flex flex-col sm:flex-row gap-6 p-6">
                    
                    {/* Blog Image - Small Left Side */}
                    <div className="flex-shrink-0">
                      <div className="relative w-full sm:w-[300px] h-[220px] rounded-lg overflow-hidden bg-white border border-gray-200">
                        <img 
                          src={post.image} 
                          alt={post.title}
                          className="w-full h-full object-cover"
                        />
                      </div>
                    </div>

                    {/* Blog Content - Right Side */}
                    <div className="flex-1">
                      {/* Title */}
                      <Link to={post.link}>
                        <h3 className="text-xl sm:text-2xl font-bold text-[#19354a] mb-3 hover:text-[#39a5d3] transition-colors cursor-pointer">
                          {post.title}
                        </h3>
                      </Link>

                      {/* Category Tag */}
                      <div className="mb-3">
                        <span className="inline-block px-4 py-1.5 bg-[#19354a] text-white rounded-full font-semibold text-sm">
                          {post.category}
                        </span>
                      </div>

                      {/* Meta Info */}
                      <div className="flex flex-wrap items-center gap-4 text-sm text-[#19354a] mb-4">
                        <div className="flex items-center gap-2">
                          <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                            <path fillRule="evenodd" d="M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z" clipRule="evenodd" />
                          </svg>
                          <span>{post.author}</span>
                        </div>
                        <div className="flex items-center gap-2">
                          <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                            <path fillRule="evenodd" d="M6 2a1 1 0 00-1 1v1H4a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-1V3a1 1 0 10-2 0v1H7V3a1 1 0 00-1-1zm0 5a1 1 0 000 2h8a1 1 0 100-2H6z" clipRule="evenodd" />
                          </svg>
                          <span>Published : {post.date}</span>
                        </div>
                      </div>

                      <div className="flex items-center gap-2 text-sm text-[#19354a] mb-4">
                        <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                          <path fillRule="evenodd" d="M6 2a1 1 0 00-1 1v1H4a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-1V3a1 1 0 10-2 0v1H7V3a1 1 0 00-1-1zm0 5a1 1 0 000 2h8a1 1 0 100-2H6z" clipRule="evenodd" />
                        </svg>
                        <span>Last Updated : {post.date}</span>
                      </div>

                      {/* Excerpt */}
                      <p className="text-gray-700 leading-relaxed text-sm sm:text-base mb-4">
                        {post.excerpt}
                      </p>

                      {/* Read More Link */}
                      <Link 
                        to={post.link}
                        className="inline-flex items-center gap-2 text-[#39a5d3] font-semibold hover:gap-3 transition-all"
                      >
                        Read Full Article
                        <svg className="w-5 h-5" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" d="M17 8l4 4m0 0l-4 4m4-4H3" />
                        </svg>
                      </Link>
                    </div>

                  </div>
                </motion.article>
              ))}

              {/* No Posts Found */}
              {currentPosts.length === 0 && (
                <div className="text-center py-12">
                  <p className="text-gray-500 text-lg">No blog posts found in this category.</p>
                </div>
              )}

              {/* PAGINATION */}
              {totalPages > 1 && (
                <div className="flex justify-center items-center gap-2 mt-12">
                  {/* Previous Button */}
                  <button
                    onClick={() => paginate(currentPage - 1)}
                    disabled={currentPage === 1}
                    className={`px-4 py-2 rounded-lg font-semibold transition-all ${
                      currentPage === 1
                        ? 'bg-gray-200 text-gray-400 cursor-not-allowed'
                        : 'bg-[#39a5d3] text-white hover:bg-[#2a8db8]'
                    }`}
                  >
                    Previous
                  </button>

                  {/* Page Numbers */}
                  {[...Array(totalPages)].map((_, index) => (
                    <button
                      key={index + 1}
                      onClick={() => paginate(index + 1)}
                      className={`w-10 h-10 rounded-lg font-semibold transition-all ${
                        currentPage === index + 1
                          ? 'bg-[#19354a] text-white'
                          : 'bg-gray-100 text-gray-700 hover:bg-[#39a5d3] hover:text-white'
                      }`}
                    >
                      {index + 1}
                    </button>
                  ))}

                  {/* Next Button */}
                  <button
                    onClick={() => paginate(currentPage + 1)}
                    disabled={currentPage === totalPages}
                    className={`px-4 py-2 rounded-lg font-semibold transition-all ${
                      currentPage === totalPages
                        ? 'bg-gray-200 text-gray-400 cursor-not-allowed'
                        : 'bg-[#39a5d3] text-white hover:bg-[#2a8db8]'
                    }`}
                  >
                    Next
                  </button>
                </div>
              )}

            </div>

            {/* RIGHT SIDE - Categories Sidebar */}
            <motion.aside 
              initial={{ opacity: 0, x: 50 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6 }}
              className="lg:col-span-4"
            >
              <div className="sticky top-24">
                
                {/* Categories Widget */}
                <div className="bg-white rounded-2xl border-2 border-[#19354a] p-6 mb-6">
                  <h3 className="text-xl font-bold text-[#19354a] mb-6 pb-4 border-b-2 border-gray-200">
                    Categories
                  </h3>
                  <div className="space-y-2">
                    {categories.map((category, index) => (
                      <button
                        key={index}
                        onClick={() => handleCategoryChange(category)}
                        className={`w-full text-left px-4 py-3 rounded-lg font-medium transition-all ${
                          selectedCategory === category
                            ? 'bg-[#19354a] text-white'
                            : 'bg-gray-50 text-gray-700 hover:bg-[#39a5d3] hover:text-white'
                        }`}
                      >
                        <div className="flex items-center justify-between">
                          <span>{category}</span>
                          <svg className="w-4 h-4" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" />
                          </svg>
                        </div>
                      </button>
                    ))}
                  </div>
                </div>

                {/* CTA Widget */}
                <div className="bg-gradient-to-br from-[#19354a] to-[#0f2133] rounded-2xl p-6 text-white mb-6">
                  <h3 className="text-xl font-bold mb-4">
                    Need Help Growing Your Practice?
                  </h3>
                  <p className="text-white/80 mb-6 text-sm leading-relaxed">
                    Get expert healthcare marketing advice tailored to your practice needs.
                  </p>
                  <Link 
                    to="/contact"
                    className="block w-full text-center px-6 py-3 bg-[#39a5d3] text-white rounded-lg font-semibold hover:bg-white hover:text-[#19354a] transition-all"
                  >
                    Get Free Consultation
                  </Link>
                </div>

                {/* Recent Posts Widget */}
                <div className="bg-white rounded-2xl border-2 border-[#19354a] p-6">
                  <h3 className="text-xl font-bold text-[#19354a] mb-6 pb-4 border-b-2 border-gray-200">
                    Recent Posts
                  </h3>
                  <div className="space-y-4">
                    {blogPosts.slice(0, 3).map((post, index) => (
                      <Link
                        key={index}
                        to={post.link}
                        className="block group"
                      >
                        <div className="flex gap-3">
                          <div className="w-20 h-20 flex-shrink-0 rounded-lg overflow-hidden">
                            <img 
                              src={post.image} 
                              alt={post.title}
                              className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-300"
                            />
                          </div>
                          <div className="flex-1">
                            <h4 className="text-sm font-semibold text-[#19354a] line-clamp-2 group-hover:text-[#39a5d3] transition-colors mb-1">
                              {post.title}
                            </h4>
                            <p className="text-xs text-gray-500">{post.date}</p>
                          </div>
                        </div>
                      </Link>
                    ))}
                  </div>
                </div>

              </div>
            </motion.aside>

          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Blog;